export const iconFontAwesomeHumanitarianPlaneUp = (
	<i className="fa-solid fa-plane-up"></i>
);
